import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-04563b53")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`app-nav-toggle`)
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Swap ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Pools ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Portfolio ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "toggle-link-4 px-4",
  href: "https://docs.wavelength.exchange",
  target: "_blank",
  title: "This link will open a new window"
}, "Docs ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "toggle-link-4 px-4",
  href: "https://analytics.wavelength.exchange/#/",
  target: "_blank",
  title: "This link will open a new window"
}, "Analytics ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'trade' },
      class: _normalizeClass(['toggle-link px-6', { [_ctx.activeClasses]: _ctx.isTradePage }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavTrade)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'pools' },
      class: _normalizeClass(['toggle-link-2 px-6', { [_ctx.activeClasses]: _ctx.isInvestPage }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavInvest)))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { name: 'my-portfolio' },
          class: _normalizeClass(['toggle-link-3 px-4', { [_ctx.activeClasses]: _ctx.isPortfolioPage }])
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _hoisted_6
  ]))
}